import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import DoubleTranslatedCustomRichText from '@/components/CustomRichText/DoubleTranslatedCustomRichText';import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InfoMsg from '@/components/UI/InfoMsg/InfoMsg';
import Spinner from '@/components/UI/Spinner/Spinner';
import * as Constants from '@/helpers/constants';
import { getEditorId, removeParagraphTags, tabLowerCase } from '@/helpers/utils';
import useToastContext from '@/hooks/useToastContext';
import { setHelpSummaryFeedback } from '@/redux/Help/help.action';
import { getHelpSummaryFeedback } from '@/redux/Help/help.reducer';
import administrationServices from '@/services/administrationServices';
import { ReduxHelp } from '@/types';
import styles from '../HelpText.module.scss';

type PlantFeedbackHelpTextProps = {
  helpSummaryFeedback: ReduxHelp;
  setSummaryFeedback: (data: ReduxHelp) => void;
};

const PlantFeedbackHelpText: React.FC<PlantFeedbackHelpTextProps> = (props) => {
  const { t } = useTranslation();
  const tab = tabLowerCase(window.location.pathname.split('/')[4]);
  const [originalValues, setOriginalValues] = useState({});
  const { helpSummaryFeedback, setSummaryFeedback } = props;
  const isLoading = helpSummaryFeedback && !helpSummaryFeedback.SUMMARY_FEEDBACK_TAB;
  const { addToast } = useToastContext();
  const SUMMARY_FEEDBACK_TAB = 'SUMMARY_FEEDBACK_TAB';
  const SUMMARY_FEEDBACK_PLANT_FEEDBACK = 'SUMMARY_FEEDBACK_PLANT_FEEDBACK';

  const ID_GENERAL_SUMMARY_FEEDBACK = 'general-summaryFeedback';
  const ID_SUMMARY_FEEDBACK_PLANT_FEEDBACK = 'summaryFeedback-plantFeedback';

  useEffect(() => {
    administrationServices.getHelp(tab)
      .then((data) => {
        const values = helpSummaryFeedback && helpSummaryFeedback?.modified ? helpSummaryFeedback : data;
        setSummaryFeedback(values);
        setOriginalValues(values);
      })
      .catch((error) => addToast(error.message, 'ERROR'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWysiwygChange = (lang, label, data) => {
    const propValues = { ...helpSummaryFeedback[label] };
    const isModified = removeParagraphTags(data) !== removeParagraphTags(originalValues[label][lang]);
    const newState = {
      ...helpSummaryFeedback,
      [label]: {
        ...propValues,
        [lang]: data,
      },
      modified: isModified,
    };

    if (isModified) {
      setSummaryFeedback(newState as unknown as ReduxHelp);
      setOriginalValues(newState);
    }
  };

  return (
    <>
      {isLoading && <Spinner isVisible isMask />}
      {!isLoading && (
        <>
          <InfoMsg msg={t('administration.helpText.info')} />
          <AccordionPanel title={t('administration.helpText.generalText')}>
            <DoubleTranslatedCustomRichText
              id={ID_GENERAL_SUMMARY_FEEDBACK}
              title={t('helptext')}
              initialValue={helpSummaryFeedback?.SUMMARY_FEEDBACK_TAB}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, SUMMARY_FEEDBACK_TAB, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('plantFeedback.title')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_SUMMARY_FEEDBACK_PLANT_FEEDBACK}
              title={t('helptext')}
              initialValue={helpSummaryFeedback?.SUMMARY_FEEDBACK_PLANT_FEEDBACK}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, SUMMARY_FEEDBACK_PLANT_FEEDBACK, newValue)}
            />
          </AccordionPanel>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  helpSummaryFeedback: getHelpSummaryFeedback(state),
});

const actionCreators = {
  setSummaryFeedback: setHelpSummaryFeedback,
};

export default connect(mapStateToProps, actionCreators)(PlantFeedbackHelpText);
